import { useState } from "react";
import { ChevronLeft, ChevronRight, ImageIcon, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { photoSrc } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Empty } from "@/components/rp";

export const PhotoGrid = ({ photos, phases = [] }) => {
  const [idx, setIdx] = useState(null);
  const phaseName = (k) => phases.find((p) => p.key === k)?.name;
  if (!photos.length) return <Empty icon={ImageIcon} title="Nessuna foto ancora" text="Le foto del cantiere appariranno qui." data-testid="photos-empty" />;
  const cur = idx != null ? photos[idx] : null;
  const go = (d) => setIdx((i) => (i + d + photos.length) % photos.length);

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 min-[900px]:grid-cols-2 xl:grid-cols-3 gap-2" data-testid="photo-grid">
        {photos.map((p, i) => (
          <button key={p.id} onClick={() => setIdx(i)} data-testid={`photo-thumb-${i}`} className="group relative aspect-square overflow-hidden rounded-2xl bg-[#EBEBEB]">
            <img src={photoSrc(p)} alt={p.caption || "Foto cantiere"} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          </button>
        ))}
      </div>
      <Dialog open={cur != null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-5xl w-[calc(100%-24px)] bg-black border-0 p-0 rounded-[20px] sm:rounded-[20px] overflow-hidden [&>button]:hidden" data-testid="photo-lightbox">
          <DialogTitle className="sr-only">Foto</DialogTitle>
          <DialogDescription className="sr-only">Visualizzatore foto del cantiere</DialogDescription>
          {cur && (
            <div className="relative">
              <img src={photoSrc(cur)} alt={cur.caption} className="w-full max-h-[78vh] object-contain bg-black" />
              <button onClick={() => setIdx(null)} data-testid="lightbox-close" className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/15 backdrop-blur text-white flex items-center justify-center hover:bg-white/25"><X className="h-5 w-5" /></button>
              {photos.length > 1 && (
                <>
                  <button onClick={() => go(-1)} data-testid="lightbox-prev" className="absolute left-4 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white/15 backdrop-blur text-white flex items-center justify-center hover:bg-white/25"><ChevronLeft /></button>
                  <button onClick={() => go(1)} data-testid="lightbox-next" className="absolute right-4 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white/15 backdrop-blur text-white flex items-center justify-center hover:bg-white/25"><ChevronRight /></button>
                </>
              )}
              <div className="p-5 text-white">
                <p className="font-medium" data-testid="lightbox-caption">{cur.caption || "Foto del cantiere"}</p>
                <p className="text-sm text-white/60 mt-1">{[phaseName(cur.phase_key), fmtDate(cur.created_at), `${idx + 1} / ${photos.length}`].filter(Boolean).join(" · ")}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
